/*

   Common files for the TEST environment.

*/
import firebase from 'firebase/app'
import 'firebase/functions'

const serverLoc = 'https://smartkidsmarket-test.com/'
const emailDomain = 'smartkidsmarket-test.com'

const firebaseConfig = {
  apiKey: 'AIzaSyCP7bBE6rnLSw4gRXE84MdU34ANX7O27dI',
  authDomain: 'smartkidsmarket-test.firebaseapp.com',
  databaseURL: 'https://smartkidsmarket-test.firebaseio.com',
  projectId: 'smartkidsmarket-test',
  storageBucket: 'smartkidsmarket-test.appspot.com',
  messagingSenderId: '954378197493'
}

const testRecaptchaSiteKey = '6LeE9H8UAAAAAJn1_iYsm4AVbFyZp_Wzt8pb5hlm'
const stripePublishableKey = 'pk_test_1mNK2rLTCkmQVCj7R6MSg3uT'

let theFunctions = null
function getFunctions () {
  if (!theFunctions) {
    console.log('DEBUG: config is init theFunctions')
    theFunctions = firebase.functions()
  }
  return theFunctions
}

// Fix stripe pk_test_1mNK2rLTCkmQVCj7R6MSg3uT

export default {
  'serverLoc': serverLoc,
  'maxFileSize': 1024 * 1024 * 10, // 10MB,
  'firebaseConfig': firebaseConfig,
  'recaptchaSiteKey': testRecaptchaSiteKey,
  'getFunctions': getFunctions,
  'stripePublishableKey': stripePublishableKey,
  'emailDomain': emailDomain,
  'taxEndpoint': 'https://rest.avatax.com/api/v2/taxrates/byaddress',
  'taxAuthCode': 'ZGFuQHNtYXJ0a2lkc21hcmtldC5jb206dXcycjVwenc5YzVR'
}
